import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=355908ef&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=355908ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355908ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355908ef')) {
      api.createRecord('355908ef', component.options)
    } else {
      api.reload('355908ef', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=355908ef&scoped=true&", function () {
      api.rerender('355908ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21TrLsfg678Pn/JS/comp/PopupDialog.vue"
export default component.exports